import React, { Component } from 'react';
import autobind from 'autobind-decorator';
import ReactQuill from 'react-quill';

/*
 * Quill modules to attach to editor
 * See https://quilljs.com/docs/modules/ for complete options
 */
const editorModules = {
	toolbar: [
	  ['bold', 'italic', 'underline'/*, 'strike'*/],       // toggled buttons
	  ['blockquote'/*, 'code-block'*/],                    // blocks
	//   [{ 'header': 1 }, { 'header': 2 }],              // custom button values
	  [{ 'list': 'ordered'}, { 'list': 'bullet' }],    // lists
	//   [{ 'script': 'sub'}, { 'script': 'super' }],     // superscript/subscript
	  [{ 'indent': '-1'}, { 'indent': '+1' }],         // outdent/indent
	//   [{ 'direction': 'rtl' }],                        // text direction
	  [{ 'size': ['small', false, 'large', 'huge'] }], // custom dropdown
	  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],       // header dropdown
	//   [{ 'color': [] }, { 'background': [] }],         // dropdown with defaults
	//   [{ 'font': [] }],                                // font family
	//   [{ 'align': [] }],                               // text align
	  ['clean'],                                       // remove formatting
	],
	clipboard: {
		matchers: [
			[ Node.ELEMENT_NODE, function(node, delta) {
					return delta.compose(new Delta().retain(delta.length(), { 
						color: false,
						background: false,
						bold: false,
						strike: false,
						underline: false
					}
				));
				}
			] 
		]
	}
};

/*
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
const editorFormats = [
  'header', 'font', 'background', 'color', 'code', 'size',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent', 'script', 'align', 'direction',
  'link', 'image', 'code-block', 'formula', 'video'
];

class Editor extends Component {
	render() {
		const { content, onChange, onBlur = () => {} } = this.props;

		return (
			<div className='grid-container'>
				<div className="grid-x">
					<div className="cell">
						<div className="wysiwyg-editor" onClick={ this.onClick }>
							<ReactQuill
								ref={(el) => { this.reactQuillRef = el }}
								modules={ editorModules }
								formats={ editorFormats }
								value={ content }
								onChange={ onChange }
								onBlur={ onBlur }
								
							/>
							<span className="fas fa-pencil"></span>
						</div>
					</div>
				</div>
			</div>
		);
	}

	@autobind
	onClick () {
		this.reactQuillRef.focus();
	}
}

export default Editor;
